/* eslint-disable */
export async function RedirectViewPagamentos(cd_atendimento, id_pagamento) {
  return window.open(
    '/pagamentos/' + cd_atendimento + '/' + id_pagamento,
    '_blank'
  )
}
